// extracted by mini-css-extract-plugin
export default {"cls1":"wQc_mOGNLy9GYW01I1es","cls2":"Hq5OcfTFuU_ME8z8KNJh wQc_mOGNLy9GYW01I1es"};